import { FBOResponse } from "./fbo-response";
import { RetailResponse } from "./retail-response";
import { OrderResponse } from "./order-response";

export class SearchResponse {

    fboSearchResultModelList: FBOResponse[];
    customerResultModelList: RetailResponse[];
    orderModelList: OrderResponse[];
    recordsCount: number;

}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/search-response.ts